import React, { FC, ReactNode } from 'react';
require("./ProductCardThumbnailContainer.css");
var styles = {
  "Root": "ProductCardThumbnailContainer-module-Root_ouz"
};
export const ProductCardThumbnailContainer = ({
  children,
  disabled,
  target,
  href
}) => {
  if (disabled) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.Root
    }, children);
  }
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    target: target,
    className: styles.Root
  }, children);
};